import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  timeout: 120000, // 2 minutes - AI generation takes time
});

// ============================================
// BUSINESS SUBMISSIONS (returns demos!)
// ============================================

export const submitBusiness = async (data) => {
  const payload = {
    name: data.name,
    email: data.email,
    phone: data.phone || '',
    business_name: data.businessName || '',
    business_type: data.businessType || '',
    description: data.description,
    has_website: data.hasWebsite === 'da',
    current_website: data.currentWebsite || '',
    want_demo: data.wantDemo ?? true,
  };
  const response = await api.post('/submissions/', payload);
  return response.data; // Now includes { id, demos: [...], status, ... }
};

export const getSubmissionStatus = async (submissionId) => {
  const response = await api.get(`/submissions/${submissionId}/`);
  return response.data;
};

export const regenerateDemos = async (submissionId) => {
  const response = await api.post(`/submissions/${submissionId}/generate/`);
  return response.data;
};

// ============================================
// EMAIL DEMOS
// ============================================

export const emailDemos = async (submissionId) => {
  const response = await api.post(`/submissions/${submissionId}/send-email/`);
  return response.data;
};

// ============================================
// DEMO HTML URL (for iframes)
// ============================================

export const getDemoHtmlUrl = (submissionId, variantNumber) => {
  return `http://localhost:8000/api/demos/${submissionId}/${variantNumber}/`;
};

// ============================================
// COURSES
// ============================================

export const getCourses = async () => {
  const response = await api.get('/courses/');
  return response.data;
};

export const getCourseDetail = async (slug) => {
  const response = await api.get(`/courses/${slug}/`);
  return response.data;
};

// ============================================
// ENROLLMENTS
// ============================================

export const enrollInCourse = async (data) => {
  const response = await api.post('/enrollments/', {
    course: data.courseId,
    parent_name: data.parentName,
    parent_email: data.parentEmail,
    parent_phone: data.parentPhone,
    child_name: data.childName,
    child_age: data.childAge,
    message: data.message || '',
  });
  return response.data;
};

// ============================================
// CONTACT
// ============================================

export const sendContactMessage = async (data) => {
  const response = await api.post('/contact/', data);
  return response.data;
};

export default api;
